import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  accordionSummary: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  circle: {
    position: 'relative',
    borderRadius: '10px',
    zIndex: 2,
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 80px)',
  },
  number: {
    color: 'white',
    fontSize: 16,
    fontFamily: 'Poppins',
    fontWeight: 700,
    textWrap: 'nowrap',
  },
  summaryText: {
    width: '70%',
  },
  summaryTextH6: {
    fontSize: 14,
    fontFamily: 'Poppins',
    fontWeight: 700,
    color: '#0E1247',
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    padding: 5,
  },
  backgroundFloat: {
    position: 'absolute',
    background: '#5763FF',
    height: '100%',
    zIndex: 0,
    borderRadius: 5,
  },
  iconButton: {
    padding: 5,
  },
  accordionDetails: {
    color: theme.palette.primary.dark,
  },
  variableNameLabel: {
    color: theme.palette.primary.dark,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    paddingLeft: 10,
  },
  variableNameText: {
    color: theme.palette.success.dark,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingLeft: 3,
  },
  formInput: {
    width: '100%',
    marginLeft: 20,
    '& div fieldset': {
      borderColor: theme.palette.primary.dark,
    },
    '& div input': {
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
}));

export default useStyles;
